// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__vRiAF","messages":"Chat_messages___6GxN","dateDivider":"Chat_dateDivider__2iGuM"};